import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import MakePayment from '../ManageCheckout/components/MakePayment';
import { useDispatch, useSelector } from 'react-redux';
import { actionResetPaymentTransaction } from 'actions';
import {
    actionShopCartResetMembership, actionShopCartResetIDME, actionShopCartResetMembershipPackage, actionShopCartResetStateWithTourHold,
    actionShopCartResetStateWithUniqueCouponHold, actionShopCartResetGiftcards, actionResetCountryAndState, actionResetCustomer
} from 'actions';
import PaymentCompletePage from './components/PaymentCompletePage';
import ProcessingBox from '../Checkout/components/ProcessingBox';
import { actionShopCartSetManageMyBooking, actionShopCartSetRefundType, actionShopCartSetAdditionalBookingAmount, actionShopCartResetState } from 'actions';
import { actionResetBooking } from 'actions';
import { actionResetFieldValuesState } from 'actions';
import { actionDeleteGiftCardHold } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetExtraItems } from 'actions';
import { Typography, Grid, Container, Button } from '@material-ui/core';
import { actionValidateRecaptchaReset } from 'actions';
import { actionShopCartSetMMBHasPaid } from 'actions/actionShopCart';

const { RedirectAfterCheckout, Titleforloadingpayment, Subtitle1forloadingpayment, Subtitle2forloadingpayment, } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    }, hidden: {
        visibility: "hidden"
    },
    displaynone: {
        display: "none"
    }
}));

const ManageCheckout = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const reducerBooking = useSelector(state => state.reducerBooking);
    const events = useSelector(state => state.reducerShopCart.events);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const mmbHasPaid = useSelector(state => state.reducerShopCart.MMBHasPaid);

    const paymenttranstate = useSelector(state => {
        return (
            {
                loading: state.reducerPaymentTransaction.loading,
                haspaid: state.reducerPaymentTransaction.Payment.hasOwnProperty('Products'),
                paymentinfo: state.reducerPaymentTransaction.Payment,
                errormsg: state.reducerPaymentTransaction.PaymentInfoError
            }
        )

    });


    const onClickPaymentHandler = () => {
        actionStartAppLoader(dispatch);
        actionShopCartResetStateWithTourHold(dispatch, events);
        actionResetPaymentTransaction(dispatch);
        actionResetFieldValuesState(dispatch);
        actionShopCartResetStateWithUniqueCouponHold(dispatch);
        actionShopCartResetMembershipPackage(dispatch);
        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);
        actionResetBooking(dispatch);
        actionResetExtraItems(dispatch);
        actionShopCartSetManageMyBooking(dispatch, false, false);
        actionShopCartSetRefundType(dispatch, '');
        actionShopCartSetAdditionalBookingAmount(dispatch, 0);
        actionShopCartResetState(dispatch);
        actionResetCountryAndState(dispatch);
        actionShopCartSetMMBHasPaid(dispatch, false);
        actionResetCustomer(dispatch);

        if (cashless && cashless.length > 0) {
            actionDeleteGiftCardHold(dispatch, cashless[0].GiftcardHoldRef);
            actionShopCartResetGiftcards(dispatch);
        }

        actionValidateRecaptchaReset(dispatch);

        setTimeout(function () {
            actionEndAppLoader(dispatch);
            window.location.href = RedirectAfterCheckout;
        }, 2000);
    }

    useEffect(() => {
        actionResetCustomer(dispatch);
    }, [mmbHasPaid == true]);

    const redirecttofindmybpooking = () => {

        props.history.push({
            pathname: '/findmybooking'
        })
    }

    useEffect(() => {
        if (paymenttranstate.paymentinfo.hasOwnProperty('Products') == true) {
            actionShopCartSetMMBHasPaid(dispatch, true);
        }
    }, [paymenttranstate.paymentinfo.hasOwnProperty('Products') == true])

    let displayclass = "";
    if (paymenttranstate.loading)
        displayclass = classes.displaynone;
    else if (paymenttranstate.haspaid)
        displayclass = classes.displaynone;
    else if (mmbHasPaid)
        displayclass = classes.displaynone;

    return (

        <Container className={classes.root}>
            <Grid className={reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ? '' : classes.displaynone}>
                <Grid className={displayclass}>
                    <MakePayment onClickHandler={onClickPaymentHandler} refundType={props.location.refundType} booking={reducerBooking.booking[0]} amounttopay={props.location.amounttopay} />
                </Grid>
                <ProcessingBox isshow={paymenttranstate.loading} title={Titleforloadingpayment} text1={Subtitle1forloadingpayment} text2={Subtitle2forloadingpayment} ></ProcessingBox>
                <PaymentCompletePage refundType={props.location.refundType} isshow={paymenttranstate.haspaid || mmbHasPaid} mmbHasPaid={mmbHasPaid} onClickHandler={onClickPaymentHandler} transaction={paymenttranstate.paymentinfo} ></PaymentCompletePage>
            </Grid>

            <Grid container alignItems="center" style={{ minHeight: '10vh', marginTop: 30 }} justify="center" spacing={0} className={reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ? classes.displaynone : ''}>
                <Typography variant="h4" className={classes.AdjustContext}>
                    Please go to find my booking page to Update Booking.
                </Typography>
                <Grid item xs={12} md={12} align="center">

                    <Button variant="outlined" size="medium" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                        onClick={() => redirecttofindmybpooking()}>
                        Manage My Booking
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ManageCheckout;
